import { Provider } from '@angular/core';

import { ApiClient } from '../Domain/Adapter/api.client';
import { LaravelApiClientService } from '../Infrastructure/Port/laravel-api-client.service';

export const provideApiClient = (): Provider[] => {
    return [
        {
            provide: ApiClient,
            useExisting: LaravelApiClientService
        }
    ];
};
